module.exports = __webpack_public_path__ + "img/grass-tile-0003.f4aa35e1.jpg";